/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import { Link } from 'react-router-dom';

class RedditOptions extends React.Component {
    render() {
        let currentPanel = null,
            visibleSettings = null,
            constants = this.props.app.config.constants,
            postStyles = [
                { value: constants.REDDIT_POST_LINK, label: 'Link' },
                { value: constants.REDDIT_POST_IMAGE, label: 'Image' }
            ];


        if (this.props.activePanel !== 'advanced') {
            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostStyles(postStyles)}
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostStyles(postStyles)}
                    </div>
                )
            }
            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }
};

export default SocialPanelModule(RedditOptions);
